import { useQuery, useMutation, queryCache } from 'react-query'
import {
  CustomLayerCreateParams,
  CustomLayerUpdateParams,
  CustomLayerStyle,
  CustomLayer,
} from 'models/custom-layer'
import { CustomLayerRepository } from 'repository/custom-layer'

export const useFetchCustomLayers = (options?: any) => {
  const { status, data, error } = useQuery('custom-layers', CustomLayerRepository.fetchAll, options)

  return {
    status,
    customLayers: data,
    error,
  }
}

export const useFetchCustomLayer = (modelId: string, options?: any) => {
  const { status, customLayers, error } = useFetchCustomLayers(options)
  const customLayer = customLayers?.find((model) => parseInt(model.id) === parseInt(modelId))

  return {
    status,
    customLayer,
    error,
  }
}

export const useCreateCustomLayer = () => {
  return useMutation((data: CustomLayerCreateParams) => CustomLayerRepository.createNew(data), {
    onSuccess: () => {
      queryCache.refetchQueries(['custom-layers'], { force: true })
    },
  })
}

/*export const useCreateCustomLayer = () => {
  return useMutation((data: CustomLayerCreateParams) => CustomLayerRepository.create(data), {
    onSuccess: () => {
      queryCache.refetchQueries(['custom-layers'], { force: true })
    },
  })
}*/

export const useUpdateCustomLayer = (layerId: string) => {
  return useMutation(
    (data: CustomLayerUpdateParams | { viz: CustomLayerStyle }) =>
      CustomLayerRepository.updateLayer(layerId, data),
    {
      onSuccess: (data: CustomLayer) => {
        queryCache.setQueryData(['custom-layer', { layerId }], data)
        queryCache.refetchQueries(['custom-layers'], { force: true })
        queryCache.removeQueries('layers')
      },
    },
  )
}

/*export const useUpdateCustomLayer = (layerId: string) => {
  return useMutation(
    (data: CustomLayerUpdateParams | { viz: CustomLayerStyle }) =>
      CustomLayerRepository.update(layerId, data),
    {
      onSuccess: (data: CustomLayer) => {
        queryCache.setQueryData(['custom-layer', { layerId }], data)
        queryCache.refetchQueries(['custom-layers'], { force: true })
        queryCache.removeQueries('layers')
      },
    },
  )
}*/

export const useDeleteCustomLayer = (customLayerId: string) => {
  return useMutation(() => CustomLayerRepository.delete(customLayerId), {
    onSuccess: () => {
      queryCache.refetchQueries(['custom-layers'], { force: true })
    },
  })
}
